import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './design-system.css';
import './styles.css';
import './index.css';
import './styles/chat-dark.css';
import './styles/chat-simple.css';
import App from './App';
import { auth } from './firebase/config';
import { installGlobalErrorReporting, setClientErrorUserProvider } from './utils/clientErrorReporter';

// 프론트 크래시·청크 실패·처리되지 않은 예외를 서버 로그로 보낸다(2026-09 감사: 프론트 오류 사각지대).
setClientErrorUserProvider(() => auth?.currentUser?.uid || null);
installGlobalErrorReporting();

const rootElement = document.getElementById('root');

// react-snap을 위한 hydrate 지원
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} 